import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

export type TokenPoolSnapshot = {
  totalTokens: number
  availableTokens: number
  soldTokens: number
  tokenValueNairaMajor: number
}

const tokenPoolService = {
  get: async () => {
    return await axios.get('/token-pool')
  },
}

export default tokenPoolService

